import React from 'react';
import styled from 'libs/styled';
import Text from 'components/Text';
import Button from 'components/Button';
import useAppSelector from '@fogia/core-web/hooks/useAppSelector';
import { getLinkUrlFromLinkContent } from '@fogia/core-web/utils/internalRefToSlug';
import type { FooterLinkSection } from './types';

const Wrapper = styled('div')``;
const Column = styled('div')``;
const Row = styled('div')``;
const LinksWrapper = styled('div')``;

const LABEL_TYPOGRAPHY = ['Secondary/Mobile/13_120_400', null, null, null, null, 'Secondary/15_120_400'];
const LINK_TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, null, 'Primary/15_120_510_-1'];

interface LinkSectionsProps {
    sections?: FooterLinkSection[];
    isDesktop: boolean;
}

export const LinkSections = ({ sections, isDesktop }: LinkSectionsProps) => {
    const references = useAppSelector((state) => state.application?.references) ?? {};

    if (!sections?.length) return null;

    if (isDesktop) {
        return (
            <Wrapper display="flex" flexDirection="column" gap="5px" flex="1">
                {sections.map((section) => (
                    <Column key={section.title} display="flex" flexDirection="column" gap="5px">
                        <Text typography={LABEL_TYPOGRAPHY} color="var(--ui-primary-aa)">
                            {section.title}
                        </Text>
                        <LinksWrapper display="flex" flexDirection="column" gap="5px">
                            {section.links?.map((link) => {
                                const href = getLinkUrlFromLinkContent(link, references);
                                return (
                                    <div key={`${section.title}-${link.label}`}>
                                        <Button
                                            to={href || '#'}
                                            target={link.target}
                                            typography={LINK_TYPOGRAPHY}
                                            theme="textButton"
                                        >
                                            {link.label}
                                        </Button>
                                    </div>
                                );
                            })}
                        </LinksWrapper>
                    </Column>
                ))}
            </Wrapper>
        );
    }

    return (
        <>
            {sections.map((section) => (
                <Row key={section.title} display="flex" borderTop="1px solid var(--stroke-default)" py="16px">
                    <Text typography={LABEL_TYPOGRAPHY} color="var(--ui-primary-aa)" width="40%" flexShrink="0">
                        {section.title}
                    </Text>
                    <LinksWrapper display="flex" flexDirection="column">
                        {section.links?.map((link) => {
                            const href = getLinkUrlFromLinkContent(link, references);
                            return (
                                <div key={`${section.title}-${link.label}`}>
                                    <Button
                                        to={href || '#'}
                                        target={link.target}
                                        typography={LINK_TYPOGRAPHY}
                                        theme="textButton"
                                    >
                                        {link.label}
                                    </Button>
                                </div>
                            );
                        })}
                    </LinksWrapper>
                </Row>
            ))}
        </>
    );
};
